import React from "react";
import { useAppContext } from "../context/AppContext";
import { useLocation } from "react-router-dom";
import Facebook from "../assets/socials/facebook.png";
import YouTube from "../assets/socials/youtube.png";
import Instagram from "../assets/socials/instagram.png";
import Logo from "../assets/logo.png";
import { FooterTrans } from "../utils/translations";

const Footer = () => {
  const { language, country } = useAppContext();
  const { pathname } = useLocation();

  return (
    <footer className="w-full md:pb-1 pb-2">
      <div className=" border-t border-[#D0BFAE]">
      <div className="md:w-10/12 mx-auto px-4 flex flex-col md:flex-row justify-between pt-2 md:text-left text-center">
        {/* Brand */}
        <div className="mb-2 md:mb-0 mt-auto text-xs">
          <img className="md:w-16 w-10 h-auto mb-2 mx-auto md:mx-0" alt="Instagram" src={Logo} />
          <a href="/landing">{FooterTrans[language].yogaStudio}</a>
          <p>{FooterTrans[language].rights}</p>
        </div>

        {/* Contacts Column */}
        <div className="mb-3 md:mb-0">
          <h4 className="text-xs font-semibold mb-2 md:text-left text-center">Contacts</h4>
          <ul className="space-y-1 text-xs">
            <li>Phone/WhatsApp: +972 55 911 69 75</li>
            <li>Email: anna.joy.inbox@gmail.com</li>
            <li>Ramat Gan, Hibat Tzyion, 41</li>
            {country === "RU" && <li>Соколик Анна Александровна ИНН 503228030509</li>}
          </ul>
        </div>

        {/* Documents Column */}
        <div className="mb-3 md:mb-0">
          <h4 className="text-xs font-semibold mb-2 md:text-left text-center">Documents</h4>
          <ul className="space-y-1 text-xs">
            <li>
              <a href="https://docs.google.com/document/d/1LpZBMAgSNKdRFbY5EvF1_jITyPkqX9qw/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true" target="_blank" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://docs.google.com/document/d/1N-FdV1XnIO_ctkZWrrSlXIPeud_ccFxr/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true" target="_blank" className="hover:underline">
                Terms (product sales)
              </a>
            </li>
            <li>
              <a href="https://docs.google.com/document/d/1oIk1TyyRwGe_gy0Ak0nxX_ekU0uaFX93/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true" target="_blank" className="hover:underline">
                Terms (service provision)
              </a>
            </li>
            <li>
              <a href="https://drive.google.com/file/d/1hl3btMBusjFS7r7AEsxqv6bomoSbr4Nn/view?usp=sharing" target="_blank" className="hover:underline">
                License
              </a>
            </li>
          </ul>
        </div>

        {/* Socials Column */}
        <div>
          <h4 className="text-xs font-semibold mb-2 md:text-left text-center">Follow us</h4>
          <div className="flex gap-4 mx-auto md:mx-0 w-fit">
            <a href="https://www.facebook.com/theanyajoy" target="_blank" rel="noopener noreferrer">
              <img className="w-5 h-5" alt="facebook" src={Facebook} />
            </a>
            <a href="https://www.youtube.com/@once-up-on-a-mat" target="_blank" rel="noopener noreferrer">
              <img className="w-5 h-5" alt="YouTube" src={YouTube} />
            </a>
            <a
              href={
                language === "russian"
                  ? "https://www.instagram.com/joykayoga/"
                  : "https://www.instagram.com/once.up.on.a.mat"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="w-5 h-5" alt="Instagram" src={Instagram} />
            </a>
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
